import React from 'react'
import styled from 'styled-components'

import infoIcon from '@/images/icons/info.svg'
import Tooltip from '@helios/website/src/components/tooltip'
import {focusStyles} from '@helios/website/src/styles/utils'

interface Props {
    label: string
    withSmallIcon?: boolean
    side?: 'top' | 'bottom'
    closeOnScroll?: boolean
    onMouseEnter?: () => void
}

export const InfoTooltip = ({
    label,
    onMouseEnter,
    side,
    closeOnScroll,
    withSmallIcon = true,
}: Props) => (
    <Tooltip closeOnScroll={closeOnScroll} label={label} onMouseEnter={onMouseEnter} side={side}>
        <InfoButton aria-label={label}>
            <img
                src={infoIcon}
                alt=""
                width={withSmallIcon ? 14 : 18}
                height={withSmallIcon ? 14 : 18}
                style={{maxWidth: withSmallIcon ? 14 : 18}}
            />
        </InfoButton>
    </Tooltip>
)

const InfoButton = styled.button`
    padding: 0;
    background: none;
    border-color: transparent;
    border-radius: ${({theme}) => theme.spacings.s4};
    -webkit-appearance: none;

    &:focus {
        ${focusStyles()}
    }
`
